"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _taggedTemplateLiteral2 = _interopRequireDefault(require("@babel/runtime/helpers/taggedTemplateLiteral"));

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _Constant = require("../Constant");

var _Font = require("../Constant/Font");

var _Modal = require("./Modal");

var _ = _interopRequireDefault(require("./"));

var _ProductCard = _interopRequireDefault(require("./ProductCard"));

function _templateObject() {
  var data = (0, _taggedTemplateLiteral2.default)(["\n  ", " {\n    @media (min-width: ", "px) {\n      max-height: 75vh;\n    }\n  }\n\n  ", " {\n    opacity: ", ";\n  }\n\n  ", " {\n    margin: 0;\n    max-height: 100vh;\n    max-width: unset; //overwrite max-width in Dialogue\n\n    @media print, screen and (min-width: ", "px) {\n      border-bottom-right-radius: 60px;\n    }\n\n    @media print, screen and (min-width: ", "px) {\n      min-width: 600px;\n    }\n\n    @media print, screen and (min-width: ", "px) {\n      width: unset; //overwrite width in Dialogue so width is determined by number of product cards.\n      max-width: 90%;\n      padding-top: 74px;\n    }\n  }\n\n  ", " {\n    display: none;\n\n    @media print, screen and (min-width: ", "px) {\n      display: block;\n      margin-bottom: 0;\n\n      h2 {\n        font-size: 1.5rem;\n        font-weight: 700;\n        letter-spacing: calc(0.35em / 15);\n        text-align: center;\n        font-family: ", ";\n        color: ", ";\n      }\n    }\n  }\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

var ProductModal = (0, _styledComponents.default)(_.default)(_templateObject(), _Modal.Body, _Constant.Width.SM, _Modal.Mask, function (props) {
  return props.isOpen ? 0.55 : 0;
}, _Modal.Dialogue, _Constant.Width.SM, _Constant.Width.MD, _Constant.Width.LG, _Modal.Header, _Constant.Width.MD, _Font.SECONDARY_HEADER_FONT, _Constant.Color.BLACK_SOUL);

var MultiProductModal = function MultiProductModal(_ref) {
  var productList = _ref.productList,
      closable = _ref.closable,
      isOpen = _ref.isOpen,
      onClose = _ref.onClose,
      productFilter = _ref.productFilter;
  return /*#__PURE__*/_react.default.createElement(ProductModal, {
    header: "Select a product to see your rate in a few clicks.",
    isOpen: isOpen,
    onClose: onClose,
    closable: closable
  }, /*#__PURE__*/_react.default.createElement(_ProductCard.default, {
    productList: productList,
    productFilter: productFilter
  }));
};

MultiProductModal.propTypes = {
  /** Whether or not the dismiss button should be rendered  */
  closable: _propTypes.default.bool,

  /** Array of data supplied to populate the product columns  */
  productList: _propTypes.default.array,

  /** Whether or not the modal is open */
  isOpen: _propTypes.default.bool,

  /** The maximum width of the modal  */
  onClose: _propTypes.default.func,

  /** Product names entered will not be shown on the modal */
  productFilter: _propTypes.default.array
};
_.default.propTypes = MultiProductModal.propTypes;
MultiProductModal.defaultProps = {
  closable: true,
  productList: [],
  isOpen: false,
  onClose: function onClose() {},
  productFilter: []
};
var _default = MultiProductModal;
exports.default = _default;